import { render, staticRenderFns } from "./TurnstileWidget.vue?vue&type=template&id=510e6434&scoped=true&"
import script from "./TurnstileWidget.vue?vue&type=script&lang=js&"
export * from "./TurnstileWidget.vue?vue&type=script&lang=js&"
import style0 from "./TurnstileWidget.vue?vue&type=style&index=0&id=510e6434&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510e6434",
  null
  
)

export default component.exports